import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Linki śledzące',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Media społecznościowe',
  },
  form: {
    utm_source: {
      label: 'Źródło',
      placeholder: 'Wybierz źródło',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Inne media społecznościowe',
        [CustomUtmSource.Other]: 'Inne',
      },
    },
    utm_source_details: {
      label: 'Własne źródło',
      placeholder: 'Wpisz źródło',
    },
    target_product: {
      label: 'Cel',
      placeholder: 'Wybierz cel',
    },
    target_url: {
      label: 'Docelowy URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medium',
      placeholder: 'Wpisz medium',
    },
    utm_campaign: {
      label: 'Kampania',
      placeholder: 'Wpisz kampanię',
    },
  },
  fields: {
    utm_source: 'Źródło',
    target_product: 'Cel',
    type: 'Typ',
    utm_medium: 'Medium',
    utm_campaign: 'Kampania',
    utm_referrer_id: 'ID polecającego',
  },
  buttons: {
    create_auto_links: 'Utwórz automatyczne linki',
    create_link: 'Utwórz link',
    create: 'Utwórz',
    update: 'Aktualizuj',
    copy_link: 'Kopiuj link',
    download_qr_code: 'Pobierz kod QR',
    edit: 'Edytuj',
  },
  modals: {
    auto_links_creation: {
      title: 'Czy jesteś pewny?',
      description:
        'Upewnij się, że konfiguracja sklepu jest ukończona (subdomena sklepu / domena storefront). Zmiana tych ustawień po utworzeniu linków nie wpłynie automatycznie na istniejące linki!',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
    link_got_copied: 'Link skopiowany!',
    failed_to_download_qr_code: 'Nie udało się pobrać kodu QR',
  },
};
